import React from 'react'
import ChangelogFilterGroupWrapper from './ChangelogFilterGroupWrapper'
import ChangelogFilterGroupTitle from './ChangelogFilterGroupTitle'
import ChangelogFilterList from './ChangelogFilterList'

const ChangelogFilterGroup = ({ title, filterGroupName, filter, onSelect }) => {
  return (
    <ChangelogFilterGroupWrapper>
      <ChangelogFilterGroupTitle>{title}</ChangelogFilterGroupTitle>
      <ChangelogFilterList filterGroupName={filterGroupName} filter={filter} onSelect={onSelect} />
    </ChangelogFilterGroupWrapper>
  )
}

export default ChangelogFilterGroup
